import apiClient from './client.js';

export async function sendEmail (payload) {
  const { data } = await apiClient.post('/email/messages', payload);
  return data;
}
